<script>
import InputSelect from '@/components/atoms/inputlib/components/InputSelect'
import Timepiece from '@/components/atoms/Timepiece'
import { mapGetters } from 'vuex'

export default {
    name: 'TimeSelector',
    components: {
        Timepiece,
        InputSelect,
    },
    props: {
        value: null,
        noLimit: Boolean,
        times: {
            type: Array,
            default: () => [],
        },
        allowance: {
            type: Object,
            default: () => {},
        },
        restaurant: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        ...mapGetters(['smDevice', 'locale']),
        weekday() {
            return this.$moment(this.value).isoWeekday()
        },
        allowanceDay() {
            return this.weekday !== undefined && this.allowance && this.allowance.days
                ? this.allowance.days.find((aDay) => aDay.day === this.weekday)
                : null
        },
    },
    mounted() {
        const activeTimepiece = document.getElementById('activeTimepiece')
        if (activeTimepiece) {
            this.$scrollTo(activeTimepiece, {
                container: `#timeSelectorWrapper`,
                offset:
                    document.getElementById('timeSelectorWrapper').getBoundingClientRect().height /
                    -2,
            })
        }
    },
    methods: {
        setTime(time) {
            if (typeof time?.from === 'string') time = this.$moment(time.from)
            this.$emit(
                'input',
                this.$moment(this.value)
                    .set({
                        hour: time.hour(),
                        minute: time.minute(),
                    })
                    .valueOf()
            )
        },
    },
}
</script>

<template lang="pug">
.time-selector-wrapper(id="timeSelectorWrapper")
    template(v-if="smDevice")
        input-select.w-100(
            :value="value"
            :options="times"
            :disabled="!times.length"
            :key="`time-${times.length || 0}-${noLimit}`"
            :custom-label="date => $options.filters.toTimeRange(date)"
            @input="setTime"
            no-empty)
            template(v-slot:option="prop")
                | {{ prop.option.from | toHour }}&nbsp;-&nbsp;{{ prop.option.to | toHour }}
    template(v-else)
        timepiece(
            v-for="(time, index) in times"
            :key="`time-${index}-${restaurant.id}-${noLimit}`"
            :value="value"
            :time="time"
            @input="setTime")
</template>
